import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetPassword } from '../features/authSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import eyeIcon from '../assets/images/eye.svg';
import '../styles/forgotpassword.css';
import eyeShowIcon from '../assets/images/eye_show.svg';

const ResetPasswordBox = ({ email }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validatePassword = (pwd) => {
    // At least 8 chars, 1 uppercase, 1 number, 1 special char
    return /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(pwd);
  };

  const validateEmail = (email) => {
    // Simple email regex
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    if (!validatePassword(password)) {
      setError('Password must be at least 8 characters with 1 uppercase, 1 number, and 1 special character');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    const result = await dispatch(resetPassword({ email, password }));
    if (resetPassword.fulfilled.match(result)) {
      toast.success('Password reset successful! Please login.');
      setTimeout(() => {
        navigate('/success');
      }, 1500);
    } else {
      toast.error(result.payload || 'Password reset failed');
    }
  };

  return (
     <div className="login-form">
                              <h1>Create New Password</h1>
                              <h3> Please enter and confirm your new password.<br />
        You will need to login after you reset.</h3>
         <form onSubmit={handleSubmit} className="form-info">
        <label htmlFor="password" className="form-label">Password</label>
         <div className="password-section">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                className="form-input mb-0"
                style={{
                  marginBottom: error ? '4px' : '',
                  borderColor: error ? '#D7184D' : '',
                }}
                placeholder="Enter your password"
                onChange={e => {
                  const value = e.target.value;
                  if (!value.includes(' ')) {
                    setPassword(value);
                  }
                }}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
              />
              <span
                className="ico-eye"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label="Toggle password visibility"
                role="button"
                tabIndex={0}
              >
                <img
                  src={showPassword ? eyeShowIcon : eyeIcon}
                  alt={showPassword ? 'Show password' : 'Hide password'}
                  style={{
                    width: 24,
                    height: 24,
                    opacity: 1,
                  }}
                />
              </span>
            </div>
         
          <div className="password-info-text">
          At least 8 characters with 1 uppercase, 1 number, and 1 special character
        </div>
        <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
         <div className="password-section">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                value={confirmPassword}
                className="form-input mb-0"
                style={{
                  marginBottom: error ? '4px' : '',
                  borderColor: error ? '#D7184D' : '',
                }}
                placeholder="Enter your password"
                onChange={e => {
                  const value = e.target.value;
                  if (!value.includes(' ')) {
                    setConfirmPassword(value);
                  }
                }}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                  }
                }}
              />
              <span
                className="ico-eye"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label="Toggle confirm password visibility"
                role="button"
                tabIndex={0}
              >
                <img
                  src={showConfirmPassword ? eyeShowIcon : eyeIcon}
                  alt={showConfirmPassword ? 'Show confirm password' : 'Hide confirm password'}
                  style={{
                    width: 24,
                    height: 24,
                    opacity: 1,
                  }}
                />
              </span>
            </div>
          {error && <div className="login-input-error">{error}</div>}
          <button type="submit" className="login-btn">
          Continue
        </button>
      </form>
                   
            </div>
   
  )
}

export default ResetPasswordBox;
